import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

import { SelectAgenteResult } from '../login/select-agente/select-agente-result';
import { PromotorService } from '../services/promotor/promotor.service';
import { StorageService } from '../services/storage/storage.service';
import { SelectProdutoService } from '../shared/select-produto/select-produto.service';
import { SimuladorVeiculoFichaService } from '../simulador-veiculo/services/simulador-veiculo-ficha.service';
import { environment } from './../../environments/environment';
import { LoginStorage } from './../login/login.storage';
import { SelectAgenteResultStatus } from './../login/select-agente/select-agente-result-status';
import { SelectAgenteComponent } from './../login/select-agente/select-agente.component';
import { ModalMessageComponent } from './../shared/modais/modal-message/modal-message.component';
import { MenuSharedService } from './menu-shared.service';
import { LeadsOnlineService } from '../produtos/leads/services/leads.service';
import { Omni1SalesService } from '../services/omni1-sales/omni1-sales.service';
import { LoginService } from '../login/login.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  @ViewChild('selecionarAgente', { static: true })
  selecionarAgente: SelectAgenteComponent;
  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  public version = environment.VERSION_APP;

  loginStorage: LoginStorage;
  produtos: any[];
  promotor: any;
  liberaCessao: boolean = false;
  possuiPermissaoOmni1Sales: boolean = false;
  urlOmni1Sales: string;

  public isEfetiveMais: boolean = false;
  public showSimuladorMenu = false;

  isLojistaTipoFabrica = true;

  constructor(
    loginStorage: LoginStorage,
    private readonly loginService: LoginService,
    private sharedService: MenuSharedService,
    private produtoService: SelectProdutoService,
    private promotorService: PromotorService,
    private router: Router,
    private simuladorVeciluService: SimuladorVeiculoFichaService,
    private storageService: StorageService,
    private leadsOnlineService: LeadsOnlineService,
    private omni1SalesService: Omni1SalesService
  ) {
    this.loginStorage = loginStorage;
  }

  ngOnInit() {
    this.verificaEfetiveMais();
    this.verificaTipoLojista();
    this.getExibirMenuSimulador();
    if (!this.isEfetiveMais) {
      this.verificaPromotor();
      this.getProdutos();
    }
    this.loginStorage.registerPossuioCDCLojaOuPremium(
      this.possuiCdcLojaOuPremium
    );
    this.setUrlOmni1Sales();
    this.verificaPermissaoOmni1Sales();
  }

  verificaEfetiveMais() {
    this.isEfetiveMais = this.router.url.includes('efetive-mais');
    this.verificaPromotor();
    this.getProdutos();
    this.getExibirMenuSimulador();
  }

  verificaPromotor() {
    if (this.loginStorage.usuario.promotor.id) {
      const promotorId = this.loginStorage.usuario.promotor.id;
      this.promotorService
        .getOperador(promotorId)
        .pipe(take(1))
        .subscribe((res) => this.handlePromotor(res));
    }
  }

  handlePromotor(response) {
    this.promotor = response.operador;
    this.liberaCessao = this.promotor.liberaCessao;
  }

  getProdutos(): void {
    this.produtoService
      .getProdutos()
      .pipe(take(1))
      .subscribe((res) => {
        this.produtos = res;
        this.loginStorage.registerTiposProdutos(JSON.stringify(res));
      });
  }

  private verificaTipoLojista() {
    const { lojistaTipoFabrica } = this.storageService.getSession();
    this.isLojistaTipoFabrica = lojistaTipoFabrica || false;
  }

  get isOperadorLiberaCessao() {
    return this.liberaCessao;
  }

  get posuiVeiculos() {
    return !!(this.produtos || []).filter(
      (item) => item.descricao === 'VEÍCULOS'
    )[0];
  }

  get posuiCreditoPessoal() {
    return !!(this.produtos || []).filter(
      (item) => item.descricao === 'CRÉDITO PESSOAL'
    )[0];
  }

  get posuiCdcLoja() {
    return !!(this.produtos || []).filter(
      (item) => item.descricao === 'CDC LOJA'
    )[0];
  }

  get posuiCdcPremium() {
    return !!(this.produtos || []).filter(
      (item) => item.descricao === 'CDC PREMIUM'
    )[0];
  }

  get possuiCdcLojaOuPremium() {
    return (
      !!(this.produtos || []).filter(
        (item) => item.descricao === 'CDC LOJA'
      )[0] ||
      !!(this.produtos || []).filter(
        (item) => item.descricao === 'CDC PREMIUM'
      )[0]
    );
  }

  onClickSelectAgente() {
    this.selecionarAgente.selecionar();
    this.selecionarAgente.onSelectAgente
      .pipe(take(1))
      .subscribe((result: SelectAgenteResult) => {
        this.getExibirMenuSimulador();
        if (result.status === SelectAgenteResultStatus.SUCCESS) {
          this.sharedService.notifyAgenteChange();
        } else if (result.status === SelectAgenteResultStatus.ERROR) {
          this.modalMessage.show();
        }
      });
  }

  getExibirMenuSimulador() {
    this.simuladorVeciluService
      .getExibirMenuSimulacao()
      .pipe(take(1))
      .subscribe((result) => (this.showSimuladorMenu = result.allowAccess));
  }

  async sair() {
    try {
      await lastValueFrom(this.loginService.logout());
      this.storageService.removeSessionItem('lojistaTipoFabrica');
      this.leadsOnlineService.clearOriginatorType();
      this.router.navigate(['/login']);
    } catch (resultError) {
      this.modalMessage.show('Falha ao efetuar o logout.');
    }
  }

  verificaPermissaoOmni1Sales() {
    this.omni1SalesService
      .getPermissao()
      .pipe(take(1))
      .subscribe((result) => {
        this.possuiPermissaoOmni1Sales = result.hasPermission;
      });
  }

  setUrlOmni1Sales() {
    const key = this.loginStorage.usuario.key;
    this.urlOmni1Sales = `${environment.URL_OMNI_FACIL_SISTEMA}pck_seguro.auth_omni1_sales?p_omni_key=${key}`;
  }

  redirecionarOmni1Sales() {
    window.open(this.urlOmni1Sales, '_blank');
  }
}
